import { Body, Box } from '@hover/blueprint';
import React from 'react';
import styled from '@emotion/styled';

const Mark = styled('mark')`
  background-color: #e5e5e5;
  padding-inline: 6px;
  padding-block: 2px;
  border-radius: 16px;
`;

const Description: React.FC = () => (
  <Box mb={{ base: 800, tablet: '56px' }} flexDir="column">
    <Body mb={500}>
      (Effective <Mark>Nov 26, 2022</Mark> for all new customers and&nbsp;
      <Mark>Nov 25, 2022</Mark> for existing customers)
    </Body>
    <Body mb={500}>
      By downloading or using the Software and Services (as defined below), you
      accept and agree to comply with these Terms of Use, which will govern your
      use of the Software and Services. By using the Software and Services, you
      also affirm that you are of legal age to enter into the Terms of Use.
      THESE TERMS OF USE CONSTITUTE A BINDING LEGAL AGREEMENT BETWEEN YOU AND
      HOVER. IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS OF USE, DO NOT
      DOWNLOAD THE HOVER APP AND DO NOT USE THE SOFTWARE AND SERVICES.
    </Body>
    <Body>
      These Terms of Use, with any applicable Order Documentation and exhibits
      thereto, or any agreement that incorporates these Terms of Use, shall be
      the “Agreement” between you and HOVER.
    </Body>
  </Box>
);

export default Description;
